// extracted by mini-css-extract-plugin
export default {"noiseLevel":"NoizeValue_noiseLevel__2644K","stringValue":"NoizeValue_stringValue__FzcdN","comma":"NoizeValue_comma__xGtN-"};